
interface InputProps {
  label?: string;
  name?: string;
  id?: string;
  type?: string;
  placeholder?: string;
  required?: boolean;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  autoComplete?: string;
}

export default function Input({
  label,
  name,
  id,
  type = 'text',
  placeholder,
  required = false,
  value,
  onChange,
  className = '',
  autoComplete
}: InputProps) {
  // If label is provided, render with label structure
  if (label) {
    return (
      <div className={`space-y-2 ${className}`}>
        <label htmlFor={id || name} className="block text-sm font-medium text-gray-700">
          {label} {required && <span className="text-red-500">*</span>}
        </label>
        <input
          type={type}
          id={id || name}
          name={name}
          placeholder={placeholder}
          required={required}
          value={value}
          onChange={onChange}
          autoComplete={autoComplete}
          className="w-full px-4 py-3 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent transition-all duration-200 bg-white"
        />
      </div>
    );
  }

  // If no label, render just the input
  return (
    <input
      type={type}
      id={id || name}
      name={name}
      placeholder={placeholder}
      required={required}
      value={value}
      onChange={onChange}
      autoComplete={autoComplete}
      className={`w-full px-4 py-3 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent transition-all duration-200 bg-white ${className}`}
    />
  );
}
